import * as yup from 'yup'

export const BOOKING_PAGE_NAME_MAX_LENGTH = 60

export type BookingPageNameFormData = {
  bookingPageName: string
}

export const bookingPageNameSchema = yup.object({
  bookingPageName: yup
    .string()
    .test('not-blank-only', 'Booking page name cannot contain only blank spaces', function (value) {
      const original = (this.options as { originalValue?: string }).originalValue
      if (original == null || original === '') {
        return true
      }
      return /\S/.test(original)
    })
    .transform((value) => value?.trim() ?? '')
    .max(BOOKING_PAGE_NAME_MAX_LENGTH, `Must be at most ${BOOKING_PAGE_NAME_MAX_LENGTH} characters`),
})

export function resolveBookingPageNamePrefill(
  bookingPageName: string | null | undefined,
  profileFullName: string | undefined,
): string {
  return bookingPageName ?? profileFullName ?? ''
}
